import Axios from "../config/config";

//CHAPTER API
export const ADD_CHAPTER = async (body) => {
    try {
        const response = await Axios.post('add-chapter/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const EDIT_CHAPTER = async (body) => {
    try {
        const response = await Axios.post('edit-chapter/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const VIEW_CHAPTER = async (body) => {
    try {
        const response = await Axios.post('view-chapter/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};



export const CHAPTER_LIST = async (body) => {
    try {
        const response = await Axios.post('chapter-list/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const CHAPTER_STATUS = async (body) => {
    try {
        const response = await Axios.post('chapter-status/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};